import React, {useState} from "react";
import "./Portal.css";
import {useAuth} from "../../AuthContext";
import { Navigate } from 'react-router-dom';
import {distributionItems} from "../../data/distributionItems";
import {useTranslation} from "react-i18next";
import upload from '../../img/arrow.png';

export function Portal() {
    const [currentPriceItem, setCurrentPriceItem] = React.useState(distributionItems[0]);
    const [mode, setMode] = useState('manual');
    const [csvFile, setCsvFile] = useState(null);
    const [phones, setPhones] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState(null);

    const [isLoading, setLoading] = useState(false);

    const { accessToken, user, loading, fetchWithAuth } = useAuth();

    const { t } = useTranslation();

    if (loading) return <div>Загрузка...</div>;

    if (!accessToken) return <Navigate to="/login" replace />;

    if (!user) return <div>Загрузка данных пользователя...</div>;

    const parsePhones = async () => {
        if (mode === 'manual') {
            return phones
                .split(/[\n,;]/)
                .map(p => p.replace(/\s+/g, '').trim())
                .filter(p => /^\+?\d+$/.test(p));
        }

        if (mode === 'csv' && csvFile) {
            const text = await csvFile.text();
            return text
                .split(/\r?\n/)
                .map(p => p.replace(/\s+/g, '').trim())
                .filter(p => /^\+?\d+$/.test(p));
        }
        return [];
    };

    const handleSubmit = async () => {
        setError(null);
        const phoneList = await parsePhones();
        if (!message || phoneList.length === 0) {
            setError('Укажите текст сообщения и хотя бы один номер');
            return;
        }

        setLoading(true);

        try {
            const res = await fetchWithAuth('/api/createCampaign', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    message,
                    phones: phoneList,
                    channel: currentPriceItem.title
                })
            });
            console.log('res:', res); // 👈 добавь это

            if (!res) {
                setError('Нет ответа от сервера');
                return;
            }

            const data = await res.json().catch(() => ({}));
            console.log('res.ok:', res.ok); // 👈 и это
            if (res.ok) {
                alert('Рассылка успешно создана!');
                // Очистка полей, если нужно:
                setMessage('');
                setPhones('');
                setCsvFile(null);
            } else {
                setError('Не удалось создать рассылку');
            }
        } catch (error) {
            console.error(err);
            setError('Произошла ошибка при отправке данных');
        } finally {
            setLoading(false);
        }

    };

    return (
        <div className="portalPage">
            <div className="sendContainer">
                <div className={'portalHeader'}>Создание рассылки</div>
                <div className={'sendItems'}>
                    {distributionItems.map((item, index) => (
                        <div key={index} className={currentPriceItem.id === item.id ? 'selectedSendItem' : 'sendItem'} onClick={() => {setCurrentPriceItem(item)}}>{item[t("prices.titleField")]}</div>
                    ))}
                </div>
                <div className="modeItems">
                    <div className={mode === 'manual' ? 'selectedSendItem' : 'sendItem'} onClick={() => setMode('manual')}>Ввести номера вручную</div>
                    <div className={mode === 'csv' ? 'selectedSendItem' : 'sendItem'} onClick={() => setMode('csv')}>Загрузить CSV</div>
                </div>
                {mode === 'manual' ? (
                    <div className="phoneField">
                        <div className="labelP">
                            Телефонная База
                        </div>
                        <div className="blockGeneratorContentTextareaBlock">
                                <textarea
                                    className="blockGeneratorContentTextareaBlockTextarea"
                                    placeholder="Введите номера через запятую или в столбик (только цифры)"
                                    value={phones}
                                    onChange={(e) => setPhones(e.target.value)}
                                    disabled={isLoading}
                                />
                            <div style={{ fontSize: '0.9em', marginTop: 5, whiteSpace: 'normal', wordWrap: 'breakWord', width: '100%', color: '#BABABA' }}>
                                Пример: <code style={{ backgroundColor: 'transparent', color: '#BABABA' }}>1234567890, 9876543210, 5556667777</code>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="phoneField">
                        <label className="labelP">
                            Телефонная База
                        </label>
                        <label className="customFileUpload">
                            <img alt='upload' className="imageU" src={upload} />
                            <div className="fileName">
                                {csvFile ? csvFile.name : 'Выберите файл'}
                            </div>
                            <div className="fileFormat">
                                Формат CSV
                            </div>
                            <input
                                type="file"
                                accept=".csv"
                                onChange={(e) => {
                                    if (e.target.files.length > 0) {
                                        setCsvFile(e.target.files[0]);
                                    }
                                }}
                                disabled={isLoading}
                            />
                        </label>
                    </div>
                )}
                <div>
                <label className="labelP">
                    Текст сообщения
                </label>
                <textarea
                    className="blockGeneratorContentTextareaBlockTextarea"
                    placeholder="Текст сообщения"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    disabled={isLoading}
                />
                </div>
                <button onClick={handleSubmit} className="startCampaignButton" disabled={isLoading}>
                    <div className="buttonMode">{isLoading ? 'Отправка' : 'Создать рассылку'}</div>
                </button>
                {error && <div className="loginError" style={{ color: '#268DFF' }}>{error}</div>}
            </div>
        </div>
    );
}